import { Dedupe as DedupeIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import {
  IGNORE_SENTRY_ERRORS,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
} from '../constants';
import { beforeSend } from './sentry-filter';

Sentry.init({
  dsn: SENTRY_DSN,
  release: process.env.RELEASE,
  environment: SENTRY_ENVIRONMENT,
  maxBreadcrumbs: 50,
  normalizeDepth: 6,
  ignoreErrors: IGNORE_SENTRY_ERRORS,
  integrations: [
    new DedupeIntegration(),
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      beforeNavigate: context => {
        return {
          ...context,
          name: location.pathname
            .replace(/\/tracking\/(.+)/g, '/tracking/:tracking_id')
            .replace(/\/orders\/(.+)/g, '/orders/:order_id')
            .replace(/\/payment\/(.+)/g, '/payment/:payment_id')
            .replace(/\/kyc\/(.+)/g, '/kyc/:kyc_id'),
        };
      },
    }),
  ],
  enabled:
    SENTRY_ENVIRONMENT !== '$ENVIRONMENT' && SENTRY_ENVIRONMENT !== 'local',
  tracesSampleRate: 0.2,
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'console' ? null : breadcrumb;
  },
  beforeSend,
});
